import { useIdle } from '@vueuse/core'

/** 使用者閒置時行為 */
export function useUserIdle(
  action: () => Promise<void> | void,
  /** 閒置時間 - 預設 6 小時 */
  idleTime: number = 6 * 60 * 60 * 1000
) {
  const { idle, reset } = useIdle(idleTime)

  watch(
    () => idle.value,
    async () => {
      // 使用者閒置時，自動登出
      if (idle.value) {
        await action()
        reset()
      }
    }
  )
}
